import React from 'react';

const LegendaPresenze = () => {

    const styleLegenda = {
        listStyleType: 'none',
        fontSize: '12px',
        padding: '6px 0px',
        margin: 0,
    };

    return (
        <div className='px-3'>
            <div className='px-3' style={{borderTop: '1px solid', borderColor: '#dee2e6'}}>
                <ul style={styleLegenda} className='d-flex flex-wrap flex-column flex-sm-row flex-md-row flex-lg-row'>
                    <li className='text-primary pr-2'>(EA)=Entrata Automatica</li>
                    <li className='text-success pr-5'>(UA)=Uscita Automatica</li>
                    <li className='text-primary pr-2'>(EM)=Entrata Manuale</li>
                    <li className='text-success pr-5'>(UM)=Uscita Manuale</li>
                    <li className='text-primary pr-2'>(EG)=Entrata Generata</li>
                    <li className='text-success pr-5'>(UG)=Uscita Generata</li>
                </ul>
            </div>
        </div>
    )
};

export default LegendaPresenze;
